import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { EntityModel, PermissionModel, RoleModel } from "../types";
import {
  ExpandedTable,
  IButton,
  ICheckbox,
  NotFound,
} from "../../../../ui-kit";

import { CheckboxChangeEvent } from "antd/lib/checkbox";
import HelperComponents from "./HelperComponents";
import styled from "@emotion/styled";
import { useColumns } from "../../../../hooks/useColumns";
import { useEffect } from "react";
import { useUpdatePermissions } from "../features/mutations";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left: 30px;
`;

type FormModel = {
  permissions: PermissionModel[];
  checkbox: { role: boolean }[];
};

type PermissionMatrixTableProps = {
  entity: EntityModel;
  roles: RoleModel[];
};

export const PermissionMatrixTable = ({
  entity,
  roles,
}: PermissionMatrixTableProps) => {
  const { permissions = [], entityName = "" } = entity;

  const { control, setValue, handleSubmit, watch } = useForm<FormModel>({
    defaultValues: { permissions: [] },
  });

  const { mutate, isLoading } = useUpdatePermissions();

  useEffect(() => {
    // if (!entityName) return;
    setValue("permissions", permissions);
  }, [entityName]);

  useEffect(() => {
    roles.forEach(({ id }, idx) => {
      if (watch("permissions").every((el) => el.accessToRoles[id])) {
        setValue(`checkbox.${idx}.role`, true);
      } else {
        setValue(`checkbox.${idx}.role`, false);
      }
    });
  }, [roles, JSON.stringify(watch("permissions"))]);

  const onSubmit: SubmitHandler<FormModel> = ({ permissions }) => {
    mutate({ permissions });
  };

  const columns = roles?.map(({ id, name }, index) => {
    if (id === 0) {
      return {
        title: `${name}`,
        dataIndex: "permissionName",
        align: "left",
      };
    } else {
      return {
        title: (
          <HelperComponents.TitleWrapper>
            <div>{name}</div>
            <HelperComponents.CheckboxWrapper>
              <Controller
                name={`checkbox.${index}.role`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <ICheckbox
                    checked={value}
                    onChange={(e: CheckboxChangeEvent) => {
                      onChange(e.target.checked);
                      watch("permissions").forEach((_, idx) => {
                        setValue(
                          `permissions.${idx}.accessToRoles.${id}`,
                          e.target.checked,
                        );
                      });
                    }}
                  />
                )}
              />
            </HelperComponents.CheckboxWrapper>
          </HelperComponents.TitleWrapper>
        ),
        dataIndex: ["accessToRoles", `${id}`],
        align: "center",

        render: (v, obj, idx) => {
          return (
            <HelperComponents.CheckboxWrapper>
              <Controller
                name={`permissions.${idx}.accessToRoles.${id}`}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <ICheckbox checked={value} onChange={onChange} />
                )}
              />
            </HelperComponents.CheckboxWrapper>
          );
        },
      };
    }
  });

  const cols = useColumns<PermissionModel>(columns);

  return (
    <Wrapper>
      <form onSubmit={handleSubmit(onSubmit)}>
        {roles?.length ? (
          <ExpandedTable<PermissionModel>
            style={{ minWidth: "fit-content" }}
            data={permissions}
            columns={cols}
            rowKey={(row) => row.permissionId}
            summary={() => (
              <tr>
                <td
                  colSpan={1}
                  align="right"
                  style={{ border: "none", left: 0, position:"sticky" }}
                >
                  <IButton type="submit" loading={isLoading} >
                    Сохранить
                  </IButton>
                </td>
              </tr>
            )}
          />
        ) : (
          <NotFound />
        )}
      </form>
    </Wrapper>
  );
};
